import { Controller } from "@hotwired/stimulus"

// Filtro "Tema o subtema" del buscador: lista siempre visible de casillas
// (temas[]=t-<id> | s-<id>), con buscador y temas desplegables. Cada cambio
// emite "filtro-temas:cambio", que envía el formulario (auto-submit).
//
// Un tema ya incluye a todos sus subtemas, así que no conviven: elegir un
// subtema acota su tema (lo desmarca) y elegir el tema desmarca sus subtemas.
const normalizar = (texto) => texto.normalize("NFD").replace(/[̀-ͯ]/g, "").toLowerCase()

export default class extends Controller {
  static targets = ["buscador", "tema", "subtemas", "vacio", "limpiar"]

  // ------- selección --------------------------------------------------------

  cambio(evento) {
    const casilla = evento.target
    if (casilla.checked) {
      const selector = casilla.dataset.padre
        ? `input[value="${casilla.dataset.padre}"]` // subtema: desmarca su tema
        : `input[data-padre="${casilla.value}"]`     // tema: desmarca sus subtemas
      this.element.querySelectorAll(selector).forEach((otra) => { otra.checked = false })
    }
    this.avisar()
  }

  limpiar() {
    this.casillas().forEach((casilla) => { casilla.checked = false })
    this.avisar()
  }

  avisar() {
    this.limpiarTarget.classList.toggle("hidden", !this.casillas().some((casilla) => casilla.checked))
    this.dispatch("cambio")
  }

  // ------- lista ------------------------------------------------------------

  desplegar(evento) {
    const boton = evento.currentTarget
    const abierto = boton.getAttribute("aria-expanded") !== "true"
    boton.setAttribute("aria-expanded", String(abierto))
    boton.closest("[data-filtro-temas-target='tema']")
         .querySelector("[data-filtro-temas-target='subtemas']").classList.toggle("hidden", !abierto)
  }

  // Al buscar quedan los temas que calzan (con todos sus subtemas) y los
  // subtemas que calzan, con su tema abierto. Sin término, cada tema vuelve
  // a como estaba (abierto o cerrado).
  buscar() {
    const termino = normalizar(this.buscadorTarget.value.trim())
    let alguno = false

    for (const tema of this.temaTargets) {
      const lista = tema.querySelector("[data-filtro-temas-target='subtemas']")
      const subtemas = [...lista.children]
      const temaCalza = !termino || normalizar(tema.dataset.nombre).includes(termino)
      let subCalza = false
      for (const sub of subtemas) {
        const calza = temaCalza || normalizar(sub.dataset.nombre).includes(termino)
        sub.classList.toggle("hidden", !calza)
        subCalza ||= calza && !temaCalza
      }

      const visible = temaCalza || subCalza
      tema.classList.toggle("hidden", !visible)
      alguno ||= visible

      const boton = tema.querySelector("[aria-expanded]")
      const abiertoAntes = !boton || boton.getAttribute("aria-expanded") === "true"
      lista.classList.toggle("hidden", termino ? !(subCalza || abiertoAntes) : !abiertoAntes)
    }
    this.vacioTarget.classList.toggle("hidden", alguno)
  }

  // Enter en el buscador no envía el formulario: el buscador no es un filtro.
  teclaBuscador(evento) {
    if (evento.key === "Enter") evento.preventDefault()
    if (evento.key === "Escape") {
      this.buscadorTarget.value = ""
      this.buscar()
    }
  }

  casillas() {
    return [...this.element.querySelectorAll("input[type='checkbox']")]
  }
}
